import { render, staticRenderFns } from "./top-warning.vue?vue&type=template&id=00039306&"
import script from "./top-warning.vue?vue&type=script&lang=ts&"
export * from "./top-warning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports